import styled from 'styled-components'
import { media } from '../../../utils/mediaQuery'

export const Container = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  padding-bottom: 60px;

  ${media.tabletDown} {
    padding-bottom: 100px; /* Account for FAB button */
  }
`

export const Content = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;

  ${media.tabletDown} {
    padding: 16px;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 160px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const ErrorContainer = styled.div`
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.danger}10;
  border: 1px solid ${({ theme }) => theme.colors.danger}30;
  color: ${({ theme }) => theme.colors.danger};
  margin: 16px 0;

  ${media.tabletDown} {
    padding: 12px;
    margin: 12px 0;
    font-size: ${({ theme }) => theme.typography.fontSize.small};
  }
`

export const StopMeta = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.tertiary};
  margin-top: 2px;
`
